export default __webpack_public_path__ + "static/media/ImpactoZ_Eric.4b2fa5ce.png";